import { List, useRecordContext } from "react-admin";

import { LocationRecordWithUsers } from "../types/location";
import { PatientDataGrid } from "./PatientDataGrid";

export const LocationPatientsList = () => {
  const record = useRecordContext<LocationRecordWithUsers>();

  if (!record) {
    return null;
  }

  return (
    <List resource="Patient" filter={{ locationId: record.id }} perPage={50} actions={false}>
      <PatientDataGrid showLocationColumn={false} />
    </List>
  );
};
